import React from 'react';
import './Plan.css'; // Import the new CSS file
import { useTranslation } from 'react-i18next';

function Plan() {
   const { t, i18n } = useTranslation();
  
      const changeLanguage = (e) => {
        i18n.changeLanguage(e.target.value);
    };
  return (
    <div id='plan' className='plan_container'>
      <div data-aos="zoom-in" className='plan__header-content'>
        <h1 className='plan__title plf text-color-primary font1'>
          <strong>{t('plan.title')}</strong>
        </h1>
        <p className='plan__description plf font4 px-4'>
          {t('plan.paragraph')}
        </p>
      </div>

      <div className='plan__background-wrapper'>

        <div data-aos="zoom-in" className='plan__floor-container'>

          <div className='plan__text-col'>
            <div className='plan__floor-title-row'>
              <img
                src='/assets/icons/3.png'
                alt='frame'
                className='plan__icon'
              />
              <h2 className='plan__floor-title font1 titre'>{t('plan.plan_RC')}</h2>
            </div>

            <div className=' plf plan__list-wrapper font2'>
              <p><span className='text-color-accent'>1- </span>{t('plan.plan_RC-1')}</p>
              <p><span className='text-color-accent'>2- </span>{t('plan.plan_RC-2')}</p>
              <p><span className='text-color-accent'>3- </span>{t('plan.plan_RC-3')}</p>
              <p><span className='text-color-accent'>4- </span>{t('plan.plan_RC-4')}</p>
              <p><span className='text-color-accent'>5- </span>{t('plan.plan_RC-5')}</p>
            </div>
          </div>
          
          <div className='plan__image-container'>
            <img
              src='/assets/Plan/Plan1.png'
              alt='Plan du rez-de-chaussée du musée Loukach'
              className='plan__image'
            />
          </div>
        </div>

        <br /><br /><br />
        
        <div data-aos="zoom-in" className='plan__floor-container'>
          
          <div className='plan__text-col'>
            <div className='plan__floor-title-row font1'>
              <img
                src='/assets/icons/3.png'
                alt='frame'
                className='plan__icon'
              />
              <h2 className='plan__floor-title font1 titre'>{t('plan.plan_R1')}</h2>
            </div>

            <div className='plf plan__list-wrapper font2'>
              <p><span className='text-color-accent'>6- </span>{t('plan.plan_R1-6')}</p>
              <p><span className='text-color-accent'>7- </span>{t('plan.plan_R1-7')}</p>
              <p><span className='text-color-accent'>8- </span>{t('plan.plan_R1-8')}</p>
              <p><span className='text-color-accent'>9- </span>{t('plan.plan_R1-9')}</p>
              <p><span className='text-color-accent'>10- </span>{t('plan.plan_R1-10')}</p>
              <p><span className='text-color-accent'>11- </span>{t('plan.plan_R1-11')}</p>
              <p><span className='text-color-accent'>12- </span>{t('plan.plan_R1-12')}</p>
            </div>
          </div>

          <div className='plan__image-container'>
            <img
              src='/assets/Plan/Plan2.png'
              alt='Plan de létage supérieur du musée Loukach'
              className='plan__image'
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default Plan;